<template>
  <span
    v-if="color"
    class="team-color-dot"
    :style="{ backgroundColor: color, width: size + 'px', height: size + 'px' }"
  />
</template>

<script>
export default {
  name: 'TeamColorDot',
  props: {
    // Team colour hex (e.g. "#FF9800"). Renders nothing when null/empty.
    color: {
      type: String,
      default: null
    },
    size: {
      type: [Number, String],
      default: 10
    }
  }
}
</script>

<style scoped>
.team-color-dot {
  display: inline-block;
  border-radius: 50%;
  flex: 0 0 auto;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
